"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryAPI = void 0;
var config_1 = require("../../config");
var base_1 = require("./base");
var QueryAPI = /** @class */ (function (_super) {
    __extends(QueryAPI, _super);
    function QueryAPI(config, logger) {
        var _this = _super.call(this, config_1.API_BASE_URL[config.networkName].api, config, logger) || this;
        /**
         * Page size to use for fetching orders
         */
        _this.pageSize = 20;
        var _network = config.networkName;
        // this.authToken = config.authToken || ''
        _this.chain = config_1.CHAIN[_network];
        _this.chainId = config_1.CHAIN_ID[_network];
        _this.walletChainId = "0x".concat(_this.chainId.toString(16));
        _this.chainInfo = {
            chain: config_1.CHAIN[_network],
            chainId: _this.walletChainId
        };
        // Debugging: default to nothing
        _this.logger = logger || (function (arg) { return arg; });
        return _this;
    }
    return QueryAPI;
}(base_1.Fetch));
exports.QueryAPI = QueryAPI;
